import {
  Component,
  Input,
  OnInit,
  ElementRef,
  ChangeDetectorRef,
} from '@angular/core';
import { UserAgentService } from '../../services/user-agent.service';
import Swiper from 'swiper';
import { ActivatedRoute, Router } from '@angular/router';
import { fromEvent } from 'rxjs';

@Component({
  selector: 'app-collaborations',
  templateUrl: './collaborations.component.html',
  styleUrls: [
    './collaborations.component.scss',
    './collaborations.component.en.scss',
  ],
})
export class CollaborationsComponent implements OnInit {
  @Input({ required: true }) blockData!: any;

  itemsList: any[] = []; // Complete list of items
  displayedItems: any[] = []; // Items displayed on the current page
  itemsPerPage: number = 0;
  totalPages: number = 0;
  isLoading: boolean = false;
  currentPage: number = 1;

  classMap = {
    page: 'pagination__link_a',
    element: 'pagination__link',
    list: 'pagination pagination--mt',
    elementActive: 'active',
  };

  constructor(
    private el: ElementRef,
    private userAgentService: UserAgentService,
    private cdr: ChangeDetectorRef, // Inject ChangeDetectorRef
    private router: Router,
    private route: ActivatedRoute
  ) {}

  ngOnInit(): void {
    this.itemsList = this.blockData?.itemsList || [];
    this.totalPages = this.blockData?.totalPages || 0;
    this.itemsPerPage = this.blockData?.itemsPerPage || 0;
    this.updateDisplayedItems();
    //this.scrollToElement(this.el.nativeElement);
  }

  // Update displayedItems based on the current page
  updateDisplayedItems(): void {
    const startIndex = (this.currentPage - 1) * this.itemsPerPage;
    const endIndex = startIndex + this.itemsPerPage;
    this.displayedItems = this.itemsList.slice(startIndex, endIndex);
  }

  // Method to scroll to a specific element
  scrollToElement(elementSelector: HTMLElement): void {
    // Wait for Angular's change detection to complete
    setTimeout(() => {
      //const element = document.querySelector(elementSelector);

      if (!elementSelector) return; // Exit if the element doesn't exist

      // Calculate the target scroll position
      const offset = 200; // Adjust the offset as needed
      const targetPosition =
        elementSelector.getBoundingClientRect().top +
        window.pageYOffset -
        offset;

      // Smooth scroll to the target position
      window.scrollTo({
        top: targetPosition,
        behavior: 'smooth', // Enables smooth scrolling
      });
    }, 0); // Equivalent to Vue's `$nextTick`
  }

  // Handle page change when a pagination button is clicked
  changePage(page: number): void {
    if (page !== this.currentPage) {
      this.currentPage = page;
      this.updateDisplayedItems();
      //this.scrollToElement(this.el.nativeElement);
      document.getElementById('news-articles-ref')?.scrollIntoView({
        behavior: 'smooth',
        block: 'start',
        inline: 'nearest',
      });
    }
  }

  // Generate an array for pagination bullets
  getPaginationBullets(): number[] {
    return Array.from({ length: this.totalPages }, (_, i) => i + 1);
  }
}
